<template>
  <div class="user-wwcoin-exchange-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <div>
        <h2>旺旺币兑换</h2>
        <p>查看旺旺币兑换服务、消耗数量和记录来源</p>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <el-icon class="is-loading">
        <Loading />
      </el-icon>
      <span>加载中...</span>
    </div>

    <!-- 数据展示 -->
    <div v-else-if="userWwcoinExchangeRecords">
      <!-- 统计卡片 -->
      <div class="statistics-cards">
        <el-card class="stat-card total">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon><DocumentCopy /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-label">兑换记录总数</div>
              <div class="stat-value">
                {{ userWwcoinExchangeRecords.total }}
              </div>
            </div>
          </div>
        </el-card>

        <el-card class="stat-card exchange">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon><Refresh /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-label">总兑换次数</div>
              <div class="stat-value">{{ totalExchangeCount }}</div>
            </div>
          </div>
        </el-card>

        <el-card class="stat-card wwcoin">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon><Money /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-label">总消耗旺旺币</div>
              <div class="stat-value">{{ totalWwcoinAmount }} WWB</div>
            </div>
          </div>
        </el-card>

        <el-card class="stat-card behavior">
          <div class="stat-content">
            <div class="stat-icon">
              <el-icon><UserFilled /></el-icon>
            </div>
            <div class="stat-info">
              <div class="stat-label">行测+HR面试</div>
              <div class="stat-value">{{ behaviorCount }}</div>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 筛选器 -->
      <div class="filter-section">
        <el-input
          v-model="keyword"
          placeholder="搜索用户名/服务名称"
          clearable
          style="width: 250px"
          @clear="handleSearch"
          @keyup.enter="handleSearch"
        >
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
        </el-input>

        <el-select
          v-model="filterServiceType"
          placeholder="筛选服务类型"
          clearable
          style="width: 200px; margin-left: 10px"
          @change="() => (page = 1)"
        >
          <el-option label="全部" value="" />
          <el-option label="行测+HR面试" value="behavior" />
          <el-option label="专项面试" value="special" />
          <el-option label="简历押题" value="resume" />
        </el-select>

        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="handleSearch"
        >
          <el-icon><Search /></el-icon>
          搜索
        </el-button>
      </div>

      <!-- 兑换记录表格 -->
      <el-card class="table-card">
        <el-table :data="filteredData" stripe style="width: 100%">
          <!-- 用户信息 -->
          <el-table-column label="用户" width="200">
            <template #default="{ row }">
              <div class="user-info">
                <el-avatar :src="row.user.avatar" :size="40" />
                <div class="user-details">
                  <div class="username">{{ row.user.username }}</div>
                  <div class="user-email">{{ row.user.email || '-' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- 记录ID -->
          <el-table-column label="记录ID" width="280">
            <template #default="{ row }">
              <div class="record-info">
                <div class="record-id">{{ row._id }}</div>
                <div class="user-id">用户ID: {{ row.userId }}</div>
              </div>
            </template>
          </el-table-column>

          <!-- 服务信息 -->
          <el-table-column label="服务信息" width="200">
            <template #default="{ row }">
              <div class="service-info">
                <el-tag
                  :type="getServiceTypeColor(row.serviceType)"
                  effect="dark"
                  style="margin-bottom: 8px"
                >
                  {{ row.serviceTypeName }}
                </el-tag>
                <div class="service-name">{{ row.serviceName }}</div>
                <div class="plan-name">{{ row.planName }}</div>
              </div>
            </template>
          </el-table-column>

          <!-- 兑换信息 -->
          <el-table-column label="兑换信息" width="180">
            <template #default="{ row }">
              <div class="exchange-info">
                <div class="exchange-count">
                  <el-icon><Refresh /></el-icon>
                  <span>兑换次数: {{ row.exchangeCount }}</span>
                </div>
                <div class="wwcoin-amount">
                  <el-icon><Money /></el-icon>
                  <span class="amount-value">{{ row.wwCoinAmount }} WWB</span>
                </div>
                <div class="currency">
                  <el-icon><Wallet /></el-icon>
                  <span>{{ row.currency }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- 描述 -->
          <el-table-column label="描述" width="200">
            <template #default="{ row }">
              <div class="description">{{ row.description }}</div>
            </template>
          </el-table-column>

          <!-- 元数据 -->
          <el-table-column label="详细信息" width="200">
            <template #default="{ row }">
              <div v-if="row.metadata" class="metadata">
                <div class="metadata-item">
                  <span class="label">套餐类型:</span>
                  <span class="value">{{ row.metadata.packageType }}</span>
                </div>
                <div class="metadata-item">
                  <span class="label">套餐名称:</span>
                  <span class="value">{{ row.metadata.packageName }}</span>
                </div>
                <div class="metadata-item">
                  <span class="label">兑换次数:</span>
                  <span class="value">{{ row.metadata.exchangeCount }}</span>
                </div>
              </div>
              <div v-else class="metadata empty">-</div>
            </template>
          </el-table-column>

          <!-- 来源 -->
          <el-table-column label="来源" width="120">
            <template #default="{ row }">
              <el-tag type="info" size="small">{{ row.source }}</el-tag>
            </template>
          </el-table-column>

          <!-- 创建时间 -->
          <el-table-column label="创建时间" width="180">
            <template #default="{ row }">
              {{ formatDate(row.createdAt) }}
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            v-model:current-page="page"
            v-model:page-size="limit"
            :page-sizes="[10, 20, 50, 100]"
            :total="filteredTotal"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
        </div>
      </el-card>
    </div>

    <!-- 无数据 -->
    <div v-else class="no-data">
      <el-empty description="暂无数据" />
    </div>
  </div>
</template>

<script setup>
import { getUserWwcoinExchangeRecords } from '@/api/user'
import { ref, computed } from 'vue'
import {
  DocumentCopy,
  Money,
  Wallet,
  Search,
  Loading,
  Refresh,
  UserFilled
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

const userWwcoinExchangeRecords = ref(null)
const loading = ref(true)
const page = ref(1)
const limit = ref(20)
const keyword = ref('')
const filterServiceType = ref('')

// 获取数据
const getUserWwcoinExchangeRecordsData = async () => {
  try {
    loading.value = true
    const response = await getUserWwcoinExchangeRecords(
      page.value,
      limit.value,
      keyword.value
    )
    userWwcoinExchangeRecords.value = response
  } catch (error) {
    console.error('获取数据失败:', error)
    ElMessage.error('获取数据失败')
  } finally {
    loading.value = false
  }
}

// 总兑换次数
const totalExchangeCount = computed(() => {
  if (!userWwcoinExchangeRecords.value?.data) return 0
  return userWwcoinExchangeRecords.value.data.reduce(
    (sum, item) => sum + (item.exchangeCount || 0),
    0
  )
})

// 总消耗旺旺币
const totalWwcoinAmount = computed(() => {
  if (!userWwcoinExchangeRecords.value?.data) return 0
  return userWwcoinExchangeRecords.value.data.reduce(
    (sum, item) => sum + (item.wwCoinAmount || 0),
    0
  )
})

// 行测+HR面试数量
const behaviorCount = computed(() => {
  if (!userWwcoinExchangeRecords.value?.data) return 0
  return userWwcoinExchangeRecords.value.data.filter(
    (item) => item.serviceType === 'behavior'
  ).length
})

// 过滤后的数据
const filteredData = computed(() => {
  if (!userWwcoinExchangeRecords.value?.data) return []

  let data = userWwcoinExchangeRecords.value.data

  if (filterServiceType.value) {
    data = data.filter((item) => item.serviceType === filterServiceType.value)
  }

  // 前端分页
  const start = (page.value - 1) * limit.value
  const end = start + limit.value
  return data.slice(start, end)
})

// 过滤后的总数（用于分页显示）
const filteredTotal = computed(() => {
  if (!userWwcoinExchangeRecords.value?.data) return 0

  let data = userWwcoinExchangeRecords.value.data

  if (filterServiceType.value) {
    data = data.filter((item) => item.serviceType === filterServiceType.value)
  }

  return data.length
})

// 获取服务类型颜色
const getServiceTypeColor = (serviceType) => {
  const colorMap = {
    behavior: 'success',
    special: 'primary',
    resume: 'warning'
  }
  return colorMap[serviceType] || 'info'
}

// 格式化日期
const formatDate = (dateString) => {
  if (!dateString) return '-'
  const date = new Date(dateString)
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

// 搜索
const handleSearch = () => {
  page.value = 1
  getUserWwcoinExchangeRecordsData()
}

// 分页大小改变
const handleSizeChange = () => {
  page.value = 1
  getUserWwcoinExchangeRecordsData()
}

// 页码改变
const handlePageChange = () => {
  getUserWwcoinExchangeRecordsData()
}

// 初始化加载数据
getUserWwcoinExchangeRecordsData()
</script>

<style scoped lang="scss">
.user-wwcoin-exchange-container {
  padding: 0;
  background-color: transparent;
  min-height: 100%;

  .page-header {
    margin-bottom: 20px;

    h2 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #303133;
    }
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    color: #909399;

    .el-icon {
      font-size: 48px;
      margin-bottom: 16px;
    }

    span {
      font-size: 16px;
    }
  }

  .statistics-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 20px;
    margin-bottom: 20px;

    .stat-card {
      cursor: pointer;
      transition: transform 0.3s, box-shadow 0.3s;

      .stat-content {
        display: flex;
        align-items: center;
        gap: 16px;

        .stat-icon {
          width: 56px;
          height: 56px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
        }

        .stat-info {
          flex: 1;

          .stat-label {
            font-size: 14px;
            color: #909399;
            margin-bottom: 8px;
          }

          .stat-value {
            font-size: 28px;
            font-weight: 600;
            color: #303133;
          }
        }
      }

      &.total .stat-icon {
        color: var(--admin-color-primary);
      }

      &.exchange .stat-icon {
        color: var(--admin-color-primary);
      }

      &.wwcoin .stat-icon {
        color: var(--admin-color-primary);
      }

      &.behavior .stat-icon {
        color: var(--admin-color-primary);
      }
    }
  }

  .filter-section {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .table-card {
    .user-info {
      display: flex;
      align-items: center;
      gap: 12px;

      .user-details {
        flex: 1;

        .username {
          font-weight: 500;
          color: #303133;
          margin-bottom: 4px;
        }

        .user-email {
          font-size: 12px;
          color: #909399;
        }
      }
    }

    .record-info {
      .record-id {
        font-weight: 500;
        color: #303133;
        font-size: 13px;
        margin-bottom: 4px;
        word-break: break-all;
      }

      .user-id {
        font-size: 11px;
        color: #909399;
        word-break: break-all;
      }
    }

    .service-info {
      .service-name {
        font-size: 13px;
        color: #606266;
        margin-top: 4px;
        margin-bottom: 4px;
      }

      .plan-name {
        font-size: 12px;
        color: #909399;
      }
    }

    .exchange-info {
      .exchange-count,
      .wwcoin-amount,
      .currency {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        color: #606266;
        margin-bottom: 4px;

        .el-icon {
          font-size: 14px;
          color: #909399;
        }

        .amount-value {
          font-weight: 600;
          color: #f56c6c;
        }
      }
    }

    .description {
      font-size: 13px;
      color: #606266;
      line-height: 1.4;
    }

    .metadata {
      font-size: 12px;

      .metadata-item {
        margin-bottom: 4px;
        display: flex;
        gap: 4px;

        .label {
          color: #909399;
        }

        .value {
          color: #606266;
          font-weight: 500;
        }
      }

      &.empty {
        color: #c0c4cc;
      }
    }

    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }

  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    background: white;
    border-radius: 8px;
  }
}
</style>
